// 5 minutes
export const MAX_AUDIO_LENGTH = 2 * 60;
export const MARKETING_DOMAIN_URL = "https://talegacyremembered.com";
export const PAYMENT_GATEWAY_ENDPOINT =
  "https://static.scelliuspaiement.labanquepostale.fr";
export const PLACEHOLDER_IMAGE_URL = "https://placehold.co/150x150";
export const PLACEHOLDER_IMAGE_SMALL_URL = "https://placehold.co/80x80";
export const PLACEHOLDER_IMAGE_MEDIUM_URL = "https://placehold.co/140x140";
export const MAX_IMAGE_SIZE_BYTES = 300 * 1024;
export const API_TIMEOUT_MS = 3600 * 1000;
export const INSTAGRAM_URL = "https://www.instagram.com/talegacy.remembered/";
export const LINKEDIN_URL = "https://www.linkedin.com/company/talegacy";
export const SERVICE_SESSION_ID = {
  IS_AUTOBIO: 4,
  IS_SELF_DEV: 3,
  IS_ANOTHER_STORY: 2,
  OLD_AUTOBIO: 1,
};

export const CATEGORY_ID_TO_LABEL = {
  [SERVICE_SESSION_ID.IS_ANOTHER_STORY]: "another_story",
  [SERVICE_SESSION_ID.IS_SELF_DEV]: "self_development",
  [SERVICE_SESSION_ID.IS_AUTOBIO]: "autobiography",
  [SERVICE_SESSION_ID.OLD_AUTOBIO]: "autobiography",
};

export const TOOL_CHOICE_ID = {
  NEW: 1,
  REFORMULATE: 2,
  PLAN_FROM_NOTES: 3,
  CREATE_FROM_NOTES: 4,
  GRAMMAR_CORRECTION: 5,
  HUMANIZE: 6,
};

// Tool display order for reformulate flow
export const TOOL_DISPLAY_ORDER = {
  [TOOL_CHOICE_ID.GRAMMAR_CORRECTION]: 1,
  [TOOL_CHOICE_ID.REFORMULATE]: 2,
  [TOOL_CHOICE_ID.HUMANIZE]: 3,
};
